import PropTypes from 'prop-types';
import React from 'react';

import MuiSwitch from '@glass/web/components/base/Switch';

function Switch({ value, onChange, edge, color, disabled }) {
  return (
    <MuiSwitch
      checked={!!value}
      color={color}
      disabled={disabled}
      edge={edge}
      onChange={(evt) => onChange?.(evt.target.checked)}
    />
  );
}

Switch.propTypes = {
  color: PropTypes.string,
  disabled: PropTypes.bool,
  edge: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default Switch;
